export interface RegistrationApplianceDetails {
  brand: string;
  locatedAtMailingAddress: boolean;
  merchandiseInGoodWorkingOrder: boolean;
  modelNumber: string | null;
  purchaseDate: string | Date | null;
  purchaseFrom?: string;
  purchasePrice: string | null;
  serialNumber: string | null;
  type: string;
}
